import Vue from 'vue'
import Router from 'vue-router'
import { Roles } from '@/helpers/users.js'
Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  mode: 'hash',


  routes: [
    {
      path: '/admin/',
      name: 'Admin',
      component: () => import('@/views/components/Index'),
      children: [
        {
          path: 'learner',
          name: 'Learner',
          component: () => import('@/views/components/Learner'),
          meta: { requiresAuth: true, roles: [Roles.LEARNER, Roles.COACH] },
        },
        {
          path: 'reports/accounts',
          name: 'Accounts Reports',
          component: () => import('@/views/components/AccountsReports'),
          meta: { requiresAuth: true, roles: [Roles.RESELLER, Roles.SYSADMIN] },
        },
        {
          path: 'reports/global-report',
          name: 'Global Report',
          component: () => import('@/views/components/GlobalReports'),
          meta: { requiresAuth: true, roles: [Roles.SYSADMIN] },
        },
        {
          path: 'reports/resellers',
          name: 'Accounts Resellers',
          component: () => import('@/views/components/ResellersReports'),
          meta: { requiresAuth: true, roles: [Roles.SYSADMIN] },
        },
        {
          path: 'reports/raw-export',
          name: 'Raw Export',
          component: () => import('@/views/components/RawExport'),
          meta: { requiresAuth: true, roles: [Roles.SUPER, Roles.RESEARCHER] },
        },
        {
          path: 'reports/learner-report/:sessionId',
          name: 'Learner Report',
          component: () => import('@/views/components/LearnerReport'),
          meta: { requiresAuth: true, roles: [Roles.SUPER, Roles.RESEARCHER, Roles.LEARNER] },
        },
        {
          path: 'documents',
          name: 'Documents',
          component: () => import('@/views/components/Documents'),
          meta: { requiresAuth: true },
        },
        {
          path: 'accounts',
          component: () => import('@/views/components/Accounts'),
          meta: { requiresAuth: true },
        },
        {
          path: 'accounts/dashboard',
          component: () => import('@/views/components/Dashboard'),
          meta: { requiresAuth: true },
        },
        {
          path: 'accounts/:id/edit',
          component: () => import('@/views/components/AccountsEdit'),
          meta: { requiresAuth: true },
        },
        {
          path: 'accounts/:id/create',
          component: () => import('@/views/components/AccountsEdit'),
          meta: { requiresAuth: true },
        },
        {
          path: 'classes',
          component: () => import('@/views/components/Classes'),
          meta: { requiresAuth: true, roles: [Roles.COACH, Roles.ADMIN, Roles.SYSADMIN] },
        },
        {
          path: 'classes/:id/stats',
          name: 'classStats',
          component: () => import('@/views/components/ClassStats'),
          meta: { requiresAuth: true, roles: [Roles.COACH, Roles.ADMIN, Roles.SYSADMIN] },
        },
        {
          path: 'classes/:id',
          name: 'Class',
          component: () => import('@/views/components/Class'),
          meta: { requiresAuth: true, roles: [Roles.COACH, Roles.ADMIN, Roles.SYSADMIN] },
        },
        {
          path: 'classes/:class/learner/:id',
          component: () => import('@/views/components/ClassLearnerView'),
          props: true,
          meta: { requiresAuth: true, roles: [Roles.COACH, Roles.ADMIN, Roles.SYSADMIN] },
        },
        {
          path: 'users',
          component: () => import('@/views/pages/Users'),
          meta: { requiresAuth: true, roles: [Roles.ADMIN, Roles.SYSADMIN] },
        },
        {
          path: 'users/import',
          component: () => import('@/views/components/UsersImport'),
          meta: { requiresAuth: true, roles: [Roles.ADMIN, Roles.SYSADMIN] },
        },
        {
          path: 'users/:id',
          component: () => import('@/views/components/UserView'),
          meta: { requiresAuth: true, roles: [Roles.ADMIN, Roles.SYSADMIN] },
        },
        {
          name: 'Organisation',
          path: 'dashboard',
          component: () => import('@/views/components/Dashboard'),
          meta: { requiresAuth: true, roles: [Roles.ADMIN, Roles.SYSADMIN] },
        },
        {
          path: 'devices',
          component: () => import('@/views/components/Devices'),
          meta: { requiresAuth: true, roles: [Roles.ADMIN, Roles.SYSADMIN] },
        },
        {
          path: 'developer',
          component: () => import('@/views/components/Developer'),
          meta: { requiresAuth: true, roles: [Roles.DEVELOPER] },
        },
        {
          path: 'settings',
          component: () => import('@/views/components/Settings'),
          meta: { requiresAuth: true },
        },
        {
          path: 'reports',
          component: () => import('@/views/components/ModuleSurveyExplorer'),
          meta: { requiresAuth: true },
        },
        {
          path: 'launch',
          name: 'Launch Module',
          component: () => import('@/views/pages/Launch'),
          meta: { requiresAuth: true, roles: [Roles.LEARNER, Roles.COACH] },
        },
        {
          path: '/launch/ext',
          name: 'Launch Ext',
          component: () => import('@/views/pages/Launch'),
        },
        {
          path: '/launch/:provider',
          name: 'Launch shop integration',
          component: () => import('@/views/pages/Launch'),
        },
        {
          path: '/launch',
          name: 'Launch',
          component: () => import('@/views/pages/Launch'),
        },
        {
          path: 'stream',
          component: () => import('@/views/pages/Stream'),
          meta: { requiresAuth: true, roles: [Roles.LEARNER, Roles.COACH] },
        },
        {
          path: 'catalog',
          component: () => import('@/views/components/Catalog'),
          meta: { requiresAuth: true, roles: [Roles.DEVELOPER] },
        },
        {
          path: 'catalog/:id',
          component: () => import('@/views/pages/CatalogEditPage'),
          meta: { requiresAuth: true, roles: [Roles.DEVELOPER] },
        },
        {
          path: 'integrations',
          component: () => import('@/views/components/integrations/ViewIntegrations.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: 'integrations/:id',
          component: () => import('@/views/components/integrations/ViewIntegrations.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: 'certificate/:id',
          component: () => import('@/views/pages/Certificate'),
        },
      ],
    },
    {
      path: '/learner-report/:sessionId',
      name: 'Learner Report No Sidebar',
      component: () => import('@/views/components/LearnerReport'),
      meta: { requiresAuth: true, roles: [Roles.LEARNER, Roles.COACH, Roles.DEVELOPER, Roles.ADMIN, Roles.SYSADMIN] },
    },
    {
      path: '/iframe',
      name: 'Iframe',
      component: () => import('@/views/pages/Iframe'),
    },
    {
      path: '/enrol',
      name: 'Enrol',
      component: () => import('@/views/pages/Enrol'),
    },
    {
      path: '/joinClass',
      name: 'Join Class',
      component: () => import('@/views/pages/JoinClass'),
    },
    {
      path: '/stream',
      name: 'Stream',
      component: () => import('@/views/pages/Stream'),
    },
    {
      path: '/launch/stream',
      name: 'Stream',
      component: () => import('@/views/pages/Stream'),
    },
    {
      path: '/certificate/:id',
      name: 'Certificate',
      component: () => import('@/views/pages/Certificate'),
    },
    {
      path: '/lms',
      name: 'LMS',
      component: () => import('@/views/components/lms-integration/LMSIntegration.vue'),
      props: true,
    },
    {
      path: '/lti',
      name: 'Launch Ext',
      component: () => import('@/views/pages/Launch'),
    },
    {
      name: 'Select Profile',
      path: '/selectProfile',
      component: () => import('@/views/components/UserProfileSelection'),
    },
    {
      name: 'Edit user profile',
      path: '/editProfile',
      component: () => import('@/views/components/EditUserProfile'),
    },
    {
      path: '/redirect',
      name: 'Redirect',
      component: () => import('@/views/pages/FirebaseRedirect.vue'),
    },
    {
      path: '/sessionFinished',
      name: 'Session Finished',
      component: () => import('@/views/pages/SessionFinished.vue'),
    },
    {
      path: '/:catchAll(.*)',
      name: '404',
      component: () => import('@/views/components/404'),
    },

  ],
})
